import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import { INSTRUMENT_DASHBOARD_LAYOUT } from '../lib/instrument-dashboard-layout'

export function InstrumentDashboardPageSkeleton() {
  return (
    <Box
      data-testid="instrument-dashboard-page-skeleton"
      aria-busy
      aria-label="Loading instrument dashboard"
    >
      <Skeleton variant="text" width={280} height={32} />
      <Skeleton
        variant="text"
        width={520}
        height={20}
        sx={{ mt: INSTRUMENT_DASHBOARD_LAYOUT.titleBlockToBreadcrumb }}
      />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
          gap: INSTRUMENT_DASHBOARD_LAYOUT.metricCardGap,
          mb: INSTRUMENT_DASHBOARD_LAYOUT.metricsToTimeline,
        }}
      >
        {Array.from({ length: 5 }, (_, index) => `metric-skeleton-${index + 1}`).map((skeletonId) => (
          <Skeleton
            key={skeletonId}
            variant="rounded"
            sx={{
              borderRadius: '8px',
              aspectRatio: INSTRUMENT_DASHBOARD_LAYOUT.metricTileAspectRatio,
              minHeight: INSTRUMENT_DASHBOARD_LAYOUT.metricTileMinHeightPx,
            }}
          />
        ))}
      </Box>
      <Skeleton
        variant="rounded"
        height={128}
        sx={{ mb: INSTRUMENT_DASHBOARD_LAYOUT.timelineToMainGrid, borderRadius: '8px' }}
      />
      <Grid container spacing={INSTRUMENT_DASHBOARD_LAYOUT.mainToRailGap}>
        <Grid item xs={12} lg={8}>
          <Skeleton variant="text" width={180} height={28} />
          <Skeleton variant="rounded" height={320} sx={{ mt: 2, borderRadius: '8px' }} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <Stack spacing={2}>
            <Skeleton variant="rounded" height={272} sx={{ borderRadius: '8px' }} />
            <Skeleton variant="rounded" height={220} sx={{ borderRadius: '8px' }} />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}
